var map = {
	"./audit.json": "./locales/en/audit.json",
	"./calculations.json": "./locales/en/calculations.json",
	"./cdr.json": "./locales/en/cdr.json",
	"./clients.json": "./locales/en/clients.json",
	"./controlCard.json": "./locales/en/controlCard.json",
	"./csv.json": "./locales/en/csv.json",
	"./datatable.json": "./locales/en/datatable.json",
	"./eqTypes.json": "./locales/en/eqTypes.json",
	"./equipments.json": "./locales/en/equipments.json",
	"./experiments.json": "./locales/en/experiments.json",
	"./laboratories.json": "./locales/en/laboratories.json",
	"./locations.json": "./locales/en/locations.json",
	"./lookup.json": "./locales/en/lookup.json",
	"./maintTypes.json": "./locales/en/maintTypes.json",
	"./materialTypes.json": "./locales/en/materialTypes.json",
	"./materials.json": "./locales/en/materials.json",
	"./metadata.json": "./locales/en/metadata.json",
	"./notifications.json": "./locales/en/notifications.json",
	"./orders.json": "./locales/en/orders.json",
	"./productTrends.json": "./locales/en/productTrends.json",
	"./projects.json": "./locales/en/projects.json",
	"./queryTemplate.json": "./locales/en/queryTemplate.json",
	"./reports.json": "./locales/en/reports.json",
	"./samples.json": "./locales/en/samples.json",
	"./signin.json": "./locales/en/signin.json",
	"./signup.json": "./locales/en/signup.json",
	"./specifications.json": "./locales/en/specifications.json",
	"./suppliers.json": "./locales/en/suppliers.json",
	"./tasks.json": "./locales/en/tasks.json",
	"./testPlans.json": "./locales/en/testPlans.json",
	"./tests.json": "./locales/en/tests.json",
	"./translation.json": "./locales/en/translation.json",
	"./uom.json": "./locales/en/uom.json",
	"./validation.json": "./locales/en/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locales/en sync recursive \\.(json)$";